import { Fragment, FunctionalComponent, h } from '@stencil/core';
import { LoadingAjax } from '../LoadingAjax';
import { ConfirmationIcon } from 'src/ui-components/ConfirmationIcon/ConfirmationIcon';

export interface ButtonProps {
  id?: string,
  brand: string,
  disabled?: boolean,
  buttonText?: string,
  buttonType: string,
  buttonSize?: string,
  onClick?: (e:any) => void,
  className?: string,
  hostClassName?: string,
  isLoading?: boolean,
  buttonState?: string,
  loadedText?: string,
}

export const Button: FunctionalComponent<ButtonProps> = (props) => {
  const {
    id,
    brand = "atc",
    disabled = false,
    buttonText = "Submit",
    buttonType = "primary",
    buttonSize = "",
    isLoading = false,
    onClick,
    className,
    buttonState,
    loadedText,
  } = props;

  let content;

  switch (buttonState) {
    case 'loading':
      content = (
        <LoadingAjax />
      );
      break;
    case 'loaded':
      content = (
        <Fragment>
          <div class="inline-flex items-center">
            <ConfirmationIcon />
            <span class="pl-1 animated text">
              {loadedText}
            </span>
          </div>
        </Fragment>
      );
      break;
    default:
      content = buttonText;
  }

  return (
    <host class={`theme-${brand} font-skin`}>
      <button id={id} type="button" onClick={onClick} class={`btn btn-${buttonType} ${buttonSize && `btn-${buttonSize}`} border-${buttonType} ${className}`} disabled={disabled}>
        {isLoading ? <LoadingAjax /> : content}
      </button>
    </host>
  )
}
